
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prepare-for-competitions/watch-videos-on-themes",
      function () {
        return require("private-next-pages/prepare-for-competitions/watch-videos-on-themes.tsx");
      }
    ]);
  